import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import ListItem from './listItem';

function ReadOnlyDocumentListView(props) {
  return (
    <div style={props.loading ? {position: 'relative'} : {}}>
      {props.loading && <span className="loading-overlay"/>}
      {props.documents.length > 0 &&
        <table className="two-lines">
          <thead>
            <tr>
              {props.documentsSelected && <td/>}
              <td><Translate value="document.header.name"/></td>
              <td><Translate value="document.header.status"/></td>
              {props.showRemindedDocumentsState &&
                <td><Translate value="document.header.reminderStatus"/></td>
              }
              <td><Translate value="document.header.dossiers"/></td>
              <td><Translate value="document.header.validityPeriod"/></td>
              <td/>
            </tr>
          </thead>
          <tbody>
            {props.documents.map((document, index) => (
              <ListItem
                key={`read-only-doc-${index}`}
                document={document}
                {...props}
              />
            ))}
          </tbody>
        </table>
      }
    </div>
  );
}

ReadOnlyDocumentListView.propTypes = {
  documents: PropTypes.array.isRequired,
  onDocumentFileOpen: PropTypes.func,
  onDocumentProofFileOpen: PropTypes.func,
  onCheckEvent: PropTypes.func,
  loading: PropTypes.bool,
  documentsSelected: PropTypes.array,
  allowDownload: PropTypes.bool,
  showRemindedDocumentsState: PropTypes.bool
};

export default ReadOnlyDocumentListView;
